import React, { useState } from "react";
import { Link } from "react-router-dom";
import { storeApi } from "@/lib/storefront";
import { ArrowUpRight } from "lucide-react";
import useStoreRefresh from "@/hooks/useStoreRefresh";

export default function BrandsList() {
  const [brands, setBrands] = useState([]);
  const [q, setQ] = useState("");

  useStoreRefresh(() => { storeApi.get("/brands").then((r) => setBrands(r.data || [])); }, []);

  const filtered = brands.filter((b) => !q || b.name.toLowerCase().includes(q.toLowerCase()));
  const grouped = filtered.reduce((acc, b) => {
    const l = (b.name[0] || "#").toUpperCase();
    (acc[l] ||= []).push(b);
    return acc;
  }, {});
  const letters = Object.keys(grouped).sort();

  return (
    <div className="mx-auto max-w-[1440px] px-6 py-14 md:px-10 md:py-20" data-testid="brands-list-page">
      <div className="mb-10 text-xs uppercase tracking-[0.25em] text-[#6B5158]">
        <Link to="/" className="hover:text-[#2B2127]">Home</Link>
        <span className="mx-2">/</span>
        <span>Brands</span>
      </div>
      <h1 className="font-display text-5xl md:text-[88px] leading-none">
        All <span className="font-display-soft">brands</span>
      </h1>
      <p className="mt-4 max-w-xl text-[#6B5158]">A curated selection of makers we love. Thoughtfully chosen, carefully stocked.</p>

      <input
        placeholder="Search brand..."
        value={q}
        onChange={(e) => setQ(e.target.value)}
        className="mt-8 w-full max-w-md rounded-full border border-[#E6D4CC] bg-white px-5 py-3 text-sm outline-none focus:border-[#2B2127]"
      />

      <div className="mt-14 space-y-12">
        {letters.map((letter) => (
          <div key={letter}>
            <div className="mb-4 border-b border-[#E6D4CC] pb-2 font-display text-3xl">{letter}</div>
            <div className="grid gap-x-6 gap-y-2 md:grid-cols-3 lg:grid-cols-4">
              {grouped[letter].map((b) => (
                <Link key={b.id} to={`/brand/${b.slug}`} className="group flex items-center justify-between border-b border-[#E6D4CC]/50 py-2 text-sm hover:text-[#9D5C6C]">
                  <span>{b.name}</span>
                  <ArrowUpRight size={14} className="opacity-0 transition-opacity group-hover:opacity-100" />
                </Link>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
